export interface HeaderInfo {
  name: string;
  propertyKey: 'name' | 'referencedInText' | 'modifiedAt' | 'location';
  sortIndex: number;
}

export const NOT_SORTABLE = -1;
export const HEADER_COLUMNS: {[index: string]: HeaderInfo} = {
  item: {
    name: 'Item',
    propertyKey: 'name',
    sortIndex: 0,
  },
  reference: {
    name: 'Reference',
    propertyKey: 'referencedInText',
    sortIndex: NOT_SORTABLE,
  },
  modifiedAt: {
    name: 'Modified at',
    propertyKey: 'modifiedAt',
    sortIndex: 1,
  },
  projectLocation: {
    name: 'Project location',
    propertyKey: 'location',
    sortIndex: 2,
  },
};

export function getHeaderColumn(sortStateIndex: number): HeaderInfo | undefined {
  return Object.values(HEADER_COLUMNS).find((column) => column.sortIndex === sortStateIndex);
}
